import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './DualPhotoSection.module.scss';

export default class DualPhotoSection extends Component {
  static defaultProps = {
    className: ''
  };

  static propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  };

  render() {
    const { className, image, text, title } = this.props;

    return (
      <div className={`${styles.SectionContainer} ${className}`}>
        <div
          className={styles.LeftSide}
          style={{
            backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
              image
            )})`
          }}
        />
        <div className={styles.RightSide}>
          <div className={styles.ContentContainer}>
            <div className={styles.Title}>
              <h2>{title}</h2>
            </div>
            <p
              className={styles.Text}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/DualPhotoSection/DualPhotoSection.js